<template>
  <v-container fluid class="elevation-1">
    <v-row>
      <v-col
        cols="12"
        md="9"
      >
        <v-card
          class="elevation-1"
          outlined
          tile
          v-if="persona !== ''"
        >
          <v-toolbar-title class="blue white--text pa-1">Información personal</v-toolbar-title>
          <v-divider></v-divider>
          <v-row class="pa-2">
            <v-col cols="4" md="2">
              <p class="subtitle-1">CÉDULA</p>
              <p class="text--secondary">{{ `${nacionalidadAbreviatura}-${persona.cedula}` }}</p>
            </v-col>
            <v-col cols="8" md="4">
              <p class="subtitle-1">NOMBRES Y APELLIDOS</p>
              <p class="text--secondary">{{ `${persona.prim_nombre} ${persona.segu_nombre} ${persona.prim_apellido} ${persona.segu_apellido}` }}</p>
            </v-col>
            <v-col cols="4" md="2">
              <p class="subtitle-1">SEXO</p>
              <p class="text--secondary">{{ sexo }}</p>
            </v-col>
            <v-col cols="8" md="2">
              <p class="subtitle-1">ESTADO CIVIL</p>
              <p class="text--secondary">{{ estadoCivil }}</p>
            </v-col>
            <v-col cols="6" md="8">
              <p class="subtitle-1">FECHA DE NACIMIENTO</p>
              <p class="text--secondary">{{ fechaNacimiento }}</p>
            </v-col>
            <v-col cols="6" md="4" v-if="this.$store.state.Auth.user.role === this.$store.state.TypeRole.CIUDADANO">
              <p class="subtitle-1">ESTATUS</p>
              <p :class="`${persona.tps_validated === this.$store.state.TypeValidate.APROBADO ? 'green' : 'red'} white--text`">
                {{ persona.tps_validated === this.$store.state.TypeValidate.APROBADO ? 'VALIDADO' : 'EN ESPERA DE VALIDACIÓN' }}
              </p>
            </v-col>
          </v-row>
        </v-card>
        <br v-if="persona !== ''" />
        <v-card
          class="elevation-1"
          outlined
          tile
        >
          <v-toolbar-title class="blue white--text pa-1">Información de usuario</v-toolbar-title>
          <v-divider></v-divider>
          <v-row class="pa-2">
            <v-col cols="4" md="2">
              <p class="subtitle-1">NOMBRE</p>
              <p class="text--secondary">{{ this.$store.state.Auth.user.name }}</p>
            </v-col>
            <v-col cols="6" md="3">
              <p class="subtitle-1">ROL</p>
              <p class="text--secondary">{{ this.$store.state.Auth.user.role }}</p>
            </v-col>
            <v-col cols="12" md="3">
              <p
                class="subtitle-1"
                v-if="comunidad"
              >
                COMUNIDAD
              </p>
              <p
                class="text--secondary"
                v-if="comunidad"
              >
                {{ comunidad }}
              </p>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-card
          class="elevation-1"
          outlined
          tile
        >
          <v-toolbar-title class="blue white--text pa-1">Cambiar contraseña</v-toolbar-title>
          <v-divider></v-divider>
          <v-row class="pa-5">
            <v-btn
              color="info"
              dark
              block
              @click="resetPassword"
            >
              <v-icon small>mdi-plus</v-icon>
              <v-divider class="mx-4" inset vertical></v-divider> Actualizar contraseña
            </v-btn>
            <ResetPasswordDialog
              ref="reset_password_dialog"
              :auth="true"
            />
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import ResetPasswordDialog from "@/components/dialog/ResetPassword"

export default {
  name: "perfil",
  components: {
    ResetPasswordDialog
  },
  computed: {
    ...mapState(["TypeRole", "user"]),
    ...mapGetters("Auth", [
      "persona", "sexo", "nacionalidadAbreviatura",
      "fechaNacimiento", "estadoCivil", "comunidad"
    ]),
  },
  methods: {
    resetPassword() {
      this.$refs.reset_password_dialog.showDialog = true
    }
  },
}
</script>
